<template>
  <div class="container mx-auto pb-5 max-w-[1300px]">
    <img class="object-cover saturate-150 w-full" :src="`https://api.acton-shanghai.cn${cat1_banner}`">

    <div class="py-6">
      <div v-for="piano in pianos" :key="piano.id">
        <div class="flex justify-center">
          <div class="grid gri-cols-1">
            <p class="font-bold font-mono text-4xl text-center">{{ piano.prd_name.toUpperCase() }}</p>
            <p class="text-lg text-center py-2 italic">{{ piano.cat1_nameen }}</p>
            <div class="content flex mx-auto pt-10 flex-col items-center max-w-[600px]">
              <div class="w-full flex flex-col items-center">
                <img
                  class="w-full h-auto max-w-full cursor-pointer object-cover saturate-100 lg:min-h-[400px] lg:max-h-[400px]"
                  :src="getCurrentMainImage(piano.id) || `https://api.acton-shanghai.cn${piano.prd_cover}`"
                  @click="openGallery(getCurrentMainImage(piano.id) || `https://api.acton-shanghai.cn${piano.prd_cover}`, piano.id)"
                  :alt="piano.prd_name"
                />
                <!-- 当前图的文字描述 -->
                <p v-if="getCurrentImageDescription(piano.id) || piano.prd_name" class="text-center text-gray-600/40 mt-3 w-full px-2 sm:px-4 text-sm sm:text-base mx-auto">
                  {{ getCurrentImageDescription(piano.id) || piano.prd_name }}
                </p>
              </div>
              <!-- 图库小图横向排列，一行最多5个，支持横向拖动 -->
              <div v-if="getAlbum(piano.id).length > 0 || piano.prd_cover" class="mt-4 w-full">
                <div class="overflow-x-auto scrollbar-hide w-full" style="scrollbar-width: thin; scrollbar-color: #d1d5db transparent">
                  <div class="flex gap-2 justify-start lg:justify-center px-2" style="min-width: max-content">
                    <!-- 主图缩略图 -->
                    <div v-if="piano.prd_cover" class="relative cursor-pointer group flex-shrink-0">
                      <div
                        class="relative overflow-hidden w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 rounded border-2 transition-all"
                        :class="
                          getCurrentMainImage(piano.id) === `https://api.acton-shanghai.cn${piano.prd_cover}` || (!getCurrentMainImage(piano.id) && (getAlbum(piano.id).length > 0 || piano.prd_cover))
                            ? 'border-yellow-600'
                            : 'border-gray-300 hover:border-yellow-400'
                        "
                      >
                        <img
                          class="w-full h-full object-cover"
                          :src="`https://api.acton-shanghai.cn${piano.prd_cover}`"
                          @click="changeMainImage(`https://api.acton-shanghai.cn${piano.prd_cover}`, piano.id)"
                          @dblclick="openGallery(`https://api.acton-shanghai.cn${piano.prd_cover}`, piano.id)"
                          :alt="piano.prd_name"
                        />
                      </div>
                    </div>
                    <!-- 图库缩略图 -->
                    <div v-for="item in getAlbum(piano.id)" :key="item.id" class="relative cursor-pointer group flex-shrink-0">
                      <div
                        class="relative overflow-hidden w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 rounded border-2 transition-all"
                        :class="getCurrentMainImage(piano.id) === `https://api.acton-shanghai.cn${item.pro_albu}` ? 'border-yellow-600' : 'border-gray-300 hover:border-yellow-400'"
                      >
                        <img
                          class="w-full h-full object-cover"
                          :src="`https://api.acton-shanghai.cn${item.pro_albu}`"
                          @click="changeMainImage(`https://api.acton-shanghai.cn${item.pro_albu}`, piano.id)"
                          @dblclick="openGallery(`https://api.acton-shanghai.cn${item.pro_albu}`, piano.id)"
                          :alt="piano.prd_name"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex border-b justify-center border-gray-300 mb-5 lg:min-w-[600px]">
      <div class="flex justify-center">
        <button
          :class="{ 'min-w-[12rem] py-2 px-20 border-b-4 border-gray-900 hover:text-gray-600 text-gray-800 font-bold  transition duration-200': selectedTab === 'tab1', 'py-2 px-10 border-b-4 border-gray-600/30 hover:text-gray-500 text-gray-600 font-bold': selectedTab !== 'tab1', }"
          @click="selectedTab = 'tab1'">钢琴</button>
        <button
          :class="{ 'min-w-[12rem] py-2 px-20 border-b-4 border-red-600 hover:text-gray-600 text-gray-800 font-bold  transition duration-200': selectedTab === 'tab2', 'py-2 px-10 border-b-4 border-red-600/50 hover:text-gray-500 text-gray-600 font-bold': selectedTab !== 'tab2', }"
          @click="selectedTab = 'tab2'">规格</button>
        <button v-if="uni_disc"
          :class="{ 'min-w-[12rem] py-2 px-20 border-b-4 border-yellow-600 hover:text-gray-600 text-gray-800 font-bold  transition duration-200': selectedTab === 'tab3', 'py-2 px-10 border-b-4 border-yellow-600/30 hover:text-gray-500 text-gray-600 font-bold': selectedTab !== 'tab3', }"
          @click="selectedTab = 'tab3'">细节</button>
      </div>
    </div>
  </div>

  <div class="content flex mx-auto justify-center lg:min-w-[600px] max-w-[600px] pb-16">
    <div>
      <div class="flex mx-auto w-60">
        <img class="object-cover colored-logo" src="/sauterlogo.svg">
      </div>
      <div v-if="selectedTab === 'tab1'" class="p-4 lg:min-w-[600px]">
        <div v-html="prd_features"></div>
      </div>

      <div v-if="selectedTab === 'tab2'" class="relative p-4 lg:min-w-[600px] flex justify-center">

        <img src="/images/spec-cover.jpg" class="object-cover">
        <div class="absolute z-10 top-10 lg:top-20">
          <p class="py-3 text-lg font-bold">{{ pianos[0].prd_name.toUpperCase() }}</p>
          <p class="" v-html="prd_spec"></p>
        </div>

      </div>
      <div v-if="selectedTab === 'tab3'" class="p-4  lg:min-w-[600px]">
        <p v-html="uni_disc"></p>
      </div>
    </div>
  </div>
  <p class="text-center font-bold text-xl my-10 pb-2 border-b ">更多视听</p>
  <div class="flex justify-center border-gray-300 mb-5 lg:max-w-[600px] mx-auto">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mx-5 lg:mx-0">
      <div v-for="video in videos" :key="video.id">
        <a class="relative" :href="`${video.v_url}`" target="_blank">
          <div class="hover:-translate-y-1 duration-200 hover:opacity-85">
            <div
              class="flex justify-center rounded-md border border-yellow-600/20 p-1 hover:border-2 hover:border-yellow-600/60 duration-200">
              <img class="object-fill overflow-hidden saturate-100 lg:min-w-[278px] lg:max-h-[190px] lg:min-h-[190px]"
                :src="`${video.v_cover}`">
            </div>
          </div>
          <div class="absolute top-[80px] z-10 w-full">
            <div class="flex mx-auto justify-center"><svg height="48" width="48" fill="none" viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="1.5" />
                <path
                  d="M13.8876 9.9348C14.9625 10.8117 15.5 11.2501 15.5 12C15.5 12.7499 14.9625 13.1883 13.8876 14.0652C13.5909 14.3073 13.2966 14.5352 13.0261 14.7251C12.7888 14.8917 12.5201 15.064 12.2419 15.2332C11.1695 15.8853 10.6333 16.2114 10.1524 15.8504C9.6715 15.4894 9.62779 14.7336 9.54038 13.2222C9.51566 12.7947 9.5 12.3757 9.5 12C9.5 11.6243 9.51566 11.2053 9.54038 10.7778C9.62779 9.26636 9.6715 8.51061 10.1524 8.1496C10.6333 7.78859 11.1695 8.11466 12.2419 8.76679C12.5201 8.93597 12.7888 9.10831 13.0261 9.27492C13.2966 9.46483 13.5909 9.69274 13.8876 9.9348Z"
                  stroke="white" strokeWidth="1.5" />
              </svg></div>
          </div>
          <ul>
            <li class="pt-5">
              <div class="text-sm text-center">{{ video.prd_name.toUpperCase() }}</div>
              <div class="text-sm lg:min-h-[64px] font-semibold py-3 min-h-[60px]">
                {{ video.v_title }}
              </div>
            </li>
            <div class="lg:pt-6 pb-10 text-center">
              <a :href="`${video.v_url}`" target="_blank"
                class="border border-gray-600 rounded-full px-10 py-[12px] text-sm tracking-wider hover:bg-black hover:text-white duration-300">了解更多</a>
            </div>
          </ul>
        </a>
      </div>
      <div v-for="article in articles" :key="article.id">
        <a class="relative" :href="`${article.n_url}`" target="_blank">
          <div class="hover:-translate-y-1 duration-200 hover:opacity-85">
            <div
              class="flex justify-center rounded-md border border-yellow-600/20 p-1 hover:border-2 hover:border-yellow-600/60 duration-200">
              <img class="object-cover saturate-100 lg:min-h-[190px]" :src="`${article.n_cover}`">
            </div>
          </div>
          <ul>
            <li class="pt-5">
              <div class="text-sm text-center">{{ article.prd_name.toUpperCase() }}</div>
              <div class="lg:text-sm lg:min-h-[64px] font-semibold py-3 min-h-[60px]">
                {{ article.n_title }}
              </div>
            </li>
            <div class="lg:pt-6 pb-10 text-center">
              <a :href="`${article.n_url}`" target="_blank"
                class="border border-gray-600 rounded-full px-10 py-[12px] text-sm tracking-wider hover:bg-black hover:text-white duration-300">了解更多</a>
            </div>
          </ul>
        </a>
      </div>
    </div>
  </div>
  <detail-footer></detail-footer>

  <!-- 全屏图片画廊 -->
  <div v-if="showGallery" class="fixed inset-0 bg-black/95 backdrop-blur-sm z-[100] flex items-center justify-center" @click.self="closeGallery">
    <div class="relative w-full h-full flex items-center justify-center px-4 sm:px-8">
      <!-- 关闭按钮 -->
      <button
        @click="closeGallery"
        class="absolute top-4 right-4 sm:top-6 sm:right-6 z-10 text-white hover:text-yellow-400 transition-colors duration-200 bg-black/50 rounded-full p-2 hover:bg-black/70"
      >
        <svg class="w-6 h-6 sm:w-8 sm:h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <!-- 左箭头 -->
      <button
        v-if="allImages.length > 1"
        @click.stop="prevImage"
        class="absolute left-4 sm:left-8 z-10 text-white hover:text-yellow-400 transition-colors duration-200 bg-black/50 rounded-full p-2 sm:p-3 hover:bg-black/70"
        :disabled="currentGalleryIndex === 0"
      >
        <svg class="w-6 h-6 sm:w-8 sm:h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      <!-- 图片容器 -->
      <div class="relative max-w-full max-h-full flex items-center justify-center">
        <img
          :src="allImages[currentGalleryIndex]"
          :alt="`图片 ${currentGalleryIndex + 1} / ${allImages.length}`"
          class="max-w-full max-h-[90vh] object-contain"
          @click.stop
        />
      </div>

      <!-- 右箭头 -->
      <button
        v-if="allImages.length > 1"
        @click.stop="nextImage"
        class="absolute right-4 sm:right-8 z-10 text-white hover:text-yellow-400 transition-colors duration-200 bg-black/50 rounded-full p-2 sm:p-3 hover:bg-black/70"
        :disabled="currentGalleryIndex === allImages.length - 1"
      >
        <svg class="w-6 h-6 sm:w-8 sm:h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>

      <!-- 图片索引指示器 -->
      <div
        v-if="allImages.length > 1"
        class="absolute bottom-4 sm:bottom-6 left-1/2 transform -translate-x-1/2 z-10 bg-black/50 text-white px-4 py-2 rounded-full text-sm sm:text-base"
      >
        {{ currentGalleryIndex + 1 }} / {{ allImages.length }}
      </div>
    </div>
  </div>
</template>



<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import DetailFooter from '@/components/common/DetailFooter.vue';

const pageTitle = ref('');
const SRC_URL = "https://api.acton-shanghai.cn";

const pianos = ref([]);
const prd_features = ref("");
const cat1_banner = ref("");
const selectedTab = ref('tab1');
const prd_spec = ref("");
const uni_disc = ref("");
const videos = ref([]);
const articles = ref([]);
const route = useRoute();

// 多图相关状态：为每个钢琴存储图库数据
const albums = ref({}); // { pianoId: [album items] }
// 当前显示的主图：为每个钢琴存储当前主图
const currentMainImages = ref({}); // { pianoId: imageSrc }
// 当前图的文字描述：为每个钢琴存储当前图片描述
const currentImageDescriptions = ref({}); // { pianoId: description }

// 画廊相关状态
const showGallery = ref(false);
const currentGalleryIndex = ref(0);
const allImages = ref([]); // 画廊中所有图片的数组

// 获取指定钢琴的图库数据
const getAlbum = (pianoId) => {
  return albums.value[pianoId] || [];
};

// 获取指定钢琴的当前主图
const getCurrentMainImage = (pianoId) => {
  return currentMainImages.value[pianoId] || "";
};

// 获取指定钢琴的当前图片描述
const getCurrentImageDescription = (pianoId) => {
  return currentImageDescriptions.value[pianoId] || "";
};

// 切换主图
const changeMainImage = (imageSrc, pianoId) => {
  if (!imageSrc || !pianoId) return;
  currentMainImages.value[pianoId] = imageSrc;
  
  // 根据当前图片获取对应的 styleName
  const piano = pianos.value.find(p => p.id === pianoId);
  if (piano && piano.prd_cover && imageSrc === `${SRC_URL}${piano.prd_cover}`) {
    // 主图，从 product 中获取 styleName
    currentImageDescriptions.value[pianoId] = piano.styleName || piano.prd_name || "";
  } else {
    // 图库图片，从 album 中查找对应的 styleName
    const albumItem = getAlbum(pianoId).find((item) => item.pro_albu && `${SRC_URL}${item.pro_albu}` === imageSrc);
    currentImageDescriptions.value[pianoId] = albumItem?.styleName || "";
  }
};

// 获取指定钢琴的所有图片数组（主图 + 图库图片）
const getAllImagesForPiano = (pianoId) => {
  const images = [];
  const piano = pianos.value.find(p => p.id === pianoId);
  if (piano?.prd_cover) {
    images.push(`${SRC_URL}${piano.prd_cover}`);
  }
  const album = getAlbum(pianoId);
  if (album && album.length > 0) {
    album.forEach((item) => {
      if (item.pro_albu) {
        images.push(`${SRC_URL}${item.pro_albu}`);
      }
    });
  }
  return images;
};

// 打开画廊
const openGallery = (imageSrc, pianoId) => {
  if (!imageSrc || !pianoId) return;
  const images = getAllImagesForPiano(pianoId);
  const index = images.findIndex((img) => img === imageSrc);
  if (index !== -1) {
    currentGalleryIndex.value = index;
    allImages.value = images;
    showGallery.value = true;
    document.body.style.overflow = "hidden";
  } else if (images.length > 0) {
    // 如果找不到精确匹配，使用第一张图片
    currentGalleryIndex.value = 0;
    allImages.value = images;
    showGallery.value = true;
    document.body.style.overflow = "hidden";
  }
};

// 关闭画廊
const closeGallery = () => {
  showGallery.value = false;
  document.body.style.overflow = "";
};

// 上一张图片
const prevImage = () => {
  if (currentGalleryIndex.value > 0) {
    currentGalleryIndex.value--;
  } else {
    currentGalleryIndex.value = allImages.value.length - 1; // 循环到最后一张
  }
};

// 下一张图片
const nextImage = () => {
  if (currentGalleryIndex.value < allImages.value.length - 1) {
    currentGalleryIndex.value++;
  } else {
    currentGalleryIndex.value = 0; // 循环到第一张
  }
};

// 键盘事件处理
const handleKeydown = (event) => {
  if (!showGallery.value) return;

  switch (event.key) {
    case "Escape":
      closeGallery();
      break;
    case "ArrowLeft":
      event.preventDefault();
      prevImage();
      break;
    case "ArrowRight":
      event.preventDefault();
      nextImage();
      break;
  }
};

const cleanHtml = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const elementsWithStyle = doc.querySelectorAll('[style]');
  elementsWithStyle.forEach(element => element.removeAttribute('style'));
  return doc.body.innerHTML;
};

const fetchProducts = async () => {
  try {
    const id = route.params.id;
    const apiUrl = `https://api.acton-shanghai.cn/openRDS/api/product/id/${id}`;
    const response = await fetch(apiUrl);
    const pianoArrays = await response.json();
    pianos.value = pianoArrays;

    // 更新页面标题，使用获取到的产品名称
    if (pianoArrays.length > 0) {
      pageTitle.value = `${pianoArrays[0].prd_name.toUpperCase()} ${pianoArrays[0].cat1_nameen} | 德国SAUTER 首德钢琴`;
      // 同时更新文档标题
      document.title = pageTitle.value;
    }

    // 获取每个钢琴的图库数据
    for (const piano of pianoArrays) {
      try {
        const albumUrl = `https://api.acton-shanghai.cn/openRDS/api/album/id/${piano.id}`;
        const albumResponse = await fetch(albumUrl);
        const albumData = await albumResponse.json();
        albums.value[piano.id] = albumData || [];
        
        // 初始化时设置主图的描述
        if (piano.styleName) {
          currentImageDescriptions.value[piano.id] = piano.styleName;
        }
      } catch (error) {
        console.error(`Error fetching album for piano ${piano.id}:`, error);
        albums.value[piano.id] = [];
      }
    }

    const cat1_id = pianoArrays[0].cat1_id;
    const cat1Url = `https://api.acton-shanghai.cn/openRDS/api/cat1/list/15/id/${cat1_id}`;
    const responseCat = await fetch(cat1Url);
    const cat1Arrays = await responseCat.json();
    cat1_banner.value = cat1Arrays[0].cat1_banner;

    const videoUrl = `https://api.acton-shanghai.cn/openRDS/api/video/prd/${id}`;
    const responseVideo = await fetch(videoUrl);
    const videoArrays = await responseVideo.json();
    videos.value = videoArrays;

    const articleUrl = `https://api.acton-shanghai.cn/openRDS/api/news/prd/${id}`;
    const responseArticle = await fetch(articleUrl);
    const articleArrays = await responseArticle.json();
    articles.value = articleArrays;

    const rawHtml = pianoArrays[0].prd_features;
    prd_features.value = cleanHtml(rawHtml).replace(/<img([^>]*)src="([^"]*)"/g, (match, p1, p2) => {
      if (!p2.includes('http')) {
        return `<img${p1}src="https://api.acton-shanghai.cn${p2}"`;
      } else {
        return match;
      }
    });

    prd_spec.value = cleanHtml(pianoArrays[0].prd_spec).replace(/<img([^>]*)src="([^"]*)"/g);
    uni_disc.value = cleanHtml(pianoArrays[0].uni_disc).replace(/<img([^>]*)src="([^"]*)"/g);

  } catch (error) {
    console.error('Error fetching products:', error);
  }
};

onMounted(() => {
  fetchProducts();

  // 添加键盘事件监听
  window.addEventListener("keydown", handleKeydown);

  const tabs = document.querySelectorAll('[data-tab]');
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const tabName = tab.dataset.tab;
      const tabContent = document.getElementById(tabName);
      const allTabContents = document.querySelectorAll('.tab-content');
      allTabContents.forEach(content => content.classList.add('hidden'));
      tabContent.classList.remove('hidden');
    });
  });
});

// 组件卸载时移除事件监听
onUnmounted(() => {
  window.removeEventListener("keydown", handleKeydown);
  document.body.style.overflow = "";
});
</script>

<style scoped>
/* 隐藏滚动条但保持滚动功能 */
.scrollbar-hide {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: thin; /* Firefox */
}

.scrollbar-hide::-webkit-scrollbar {
  display: none; /* Chrome, Safari and Opera */
}

/* 平滑滚动 */
.scrollbar-hide {
  scroll-behavior: smooth;
}

/* 画廊动画 */
.fade-in {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.content img {
  display: block;
  margin: 0 auto;
}

.content P {
  line-height: 28px;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.content strong {
  line-height: 35px;
}

.colored-logo {
  filter: invert(100%);
  /* 将SVG图片反相 */
}
</style>